import HoverItem from '../../components/hover-images/hover-item'
import { ReactNode } from 'react'

export type Slide = {
    name: string
    image: string
    gradientClassName: string
    text: ReactNode
    linkText?: string
    link?: string
}

const slides: Slide[] = [
    {
        name: 'Alpha (0,0,0,0)',
        image: 'Alpha.gif',
        gradientClassName: 'bg-[linear-gradient(-135deg,rgb(0,255,153)0%,rgb(0,204,255)100%)]',
        text: (
            <>
                GIPHY is{' '}
                <HoverItem hoverId="transparent" className="font-bold">
                    transparent
                </HoverItem>
                . We embrace the why and the freedom of information act.
            </>
        ),
        linkText: 'Transparent',
        link: '/stickers',
    },
    {
        name: 'Animated',
        image: 'Animated.gif',
        gradientClassName: 'bg-[linear-gradient(45deg,rgb(97,87,255)0%,rgb(0,204,255)100%)]',
        text: (
            <>
                GIPHY is{' '}
                <HoverItem hoverId="alive" className="font-bold">
                    alive
                </HoverItem>
                . We bring things to life. We only work with and build things that move.
            </>
        ),
    },
    {
        name: 'Balance',
        image: 'Balance.gif',
        gradientClassName: 'bg-[linear-gradient(45deg,rgb(97,87,255)0%,rgb(230,70,182)100%)]',
        text: (
            <>
                GIPHY is{' '}
                <HoverItem hoverId="balance" className="font-bold">
                    fair
                </HoverItem>
                . We believe the world, the internet, the company, everything should be balanced. We strive to be a
                diverse group of weirdos who create things for everyone.
            </>
        ),
    },
    {
        name: 'Diversity',
        image: 'Diversity.gif',
        gradientClassName: 'bg-[linear-gradient(45deg,rgb(255,102,102)0%,rgb(255,243,92)100%)]',
        text: (
            <>
                GIPHY is a diverse community of people. We believe in investing in diversity of thought and experiences
                within our team to help us build products and make decisions that best serve GIPHY users around the
                world.
            </>
        ),
    },
    {
        name: 'Experimental',
        image: 'Experimental.gif',
        gradientClassName: 'bg-[linear-gradient(45deg,rgb(97,87,255)0%,rgb(0,204,255)100%)]',
        text: (
            <>
                There are no rules (okay, maybe a few). GIPHY strives to do and make things that have never been, that
                should be.
            </>
        ),
    },
    {
        name: 'Expressive',
        image: 'Expressive.gif',
        gradientClassName: 'bg-[linear-gradient(-135deg,rgb(255,102,102)0%,rgb(230,70,182)100%)]',
        text: (
            <>
                GIPHY{' '}
                <HoverItem hoverId="expressive" className="font-bold">
                    feels
                </HoverItem>
                . We are sensitive. We laugh. We cry. We are creators who use expression as our medium, and everything
                we build is an expression of who we are and what we believe.
            </>
        ),
    },
    {
        name: 'Friends',
        image: 'Friends.gif',
        gradientClassName: 'bg-[linear-gradient(-135deg,rgb(153,51,255)0%,rgb(97,87,255)100%)]',
        text: (
            <>
                GIPHY is more than casual friends. We <HoverItem hoverId="friends">hug</HoverItem>. Our products hug. We
                make the world a friendlier place.
            </>
        ),
    },
    {
        name: 'Help',
        image: 'Help.gif',
        gradientClassName: 'bg-[linear-gradient(-135deg,rgb(0,255,153)0%,rgb(0,204,255)100%)]',
        text: (
            <>
                GIPHY{' '}
                <HoverItem hoverId="help" className="font-bold">
                    helps
                </HoverItem>
                . We always offer friendly help to anyone who needs it.
            </>
        ),
    },
    {
        name: 'Inclusion',
        image: 'Inclusion.gif',
        gradientClassName: 'bg-[linear-gradient(-135deg,rgb(255,243,92)0%,rgb(153,51,255)100%)]',
        text: (
            <>
                We aim to build{' '}
                <HoverItem hoverId="inclusion" className="font-bold">
                    inclusive
                </HoverItem>{' '}
                communities, products, and environments where everyone is seen, heard, and valued. GIPHY should be a
                safe, open space where everyone is welcome to share and succeed.
            </>
        ),
    },
    {
        name: 'Infinite',
        image: 'Infinite.gif',
        gradientClassName: 'bg-[linear-gradient(45deg,rgb(255,102,102)0%,rgb(255,243,92)100%)]',
        text: (
            <>GIPHY never stops. Never stops building, rebuilding, rebuilding, laughing, looping, being who we are.</>
        ),
    },
    {
        name: 'Love',
        image: 'Love.gif',
        gradientClassName: 'bg-[linear-gradient(-135deg,rgb(255,102,102)0%,rgb(230,70,182)100%)]',
        text: (
            <>
                We{' '}
                <HoverItem hoverId="love" className="font-bold">
                    love
                </HoverItem>{' '}
                the people we work with. We only build things that we love. We work and build with passion.
            </>
        ),
    },
    {
        name: 'Weird',
        image: 'Weird.gif',
        gradientClassName: 'bg-[linear-gradient(45deg,rgb(97,87,255)0%,rgb(230,70,182)100%)]',
        text: (
            <>
                GIPHY is{' '}
                <HoverItem hoverId="weird" className="font-bold">
                    weird
                </HoverItem>
                . But in that good weird kind of way. We make weird things that people love. The weirder the better.
            </>
        ),
    },
    {
        name: 'Witty',
        image: 'Witty.gif',
        gradientClassName: 'bg-[linear-gradient(-135deg,rgb(0,204,255)0%,rgb(153,51,255)100%)]',
        text: (
            <>
                GIPHY has a sense of{' '}
                <HoverItem hoverId="witty" className="font-bold">
                    humor
                </HoverItem>
                . We’re fun and playful but with a post-intellectual laugh.
            </>
        ),
    },
]

export default slides
